import { mapGetters } from 'vuex';
import navBrowse from './nav-browse/nav-browse.vue';

export default {
  components: {
    navBrowse,
  },
  data() {
    return {
      rerender: false,
      rotationIndex: 1,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    showNavBrowser() {
      return !this.rerender;
    },
    classModifier() {
      return {
        'page-secondary-nav': true,
        'page-secondary-nav--browser': this.showNavBrowser,
      };
    },
  },
  methods: {
    handleOrientationChange() {
      this.rerender = true;
      setTimeout(() => {
        this.rerender = false;
        this.rotationIndex += 1;
      }, 300);
    },
  },
  created() {
    window.addEventListener('orientationchange', this.handleOrientationChange);
    this.handleOrientationChange();
  },
  beforeUnmount() {
    window.removeEventListener('orientationchange', this.handleOrientationChange);
  },
};
